export default {
  props: {
    index: {
      type: [ Number, undefined ],
      default: undefined
    }
  }
}
